<template>
  <div class="categories">
    <div v-for="category in categories">
      <router-link :to="'/' + category.name">{{ category.name }}</router-link>
    </div>
    <div>
      <router-link to="/about">About</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'categories',
  props: [
    'categories'
  ]
}
</script>

<style lang="scss">
@import "../assets/styles/_variables.scss";

.categories {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  width: 100%;

  @media only screen and (max-width: 512px) {
    flex-direction: column;
    justify-content: space-around;

    height: 84%;
    padding-top: 26%;

    & > div > a {
      margin-left: 28px;
      font-size: 1rem !important;
      color: $color-light !important;

      &.router-link-active {
        color: $color-dark !important;
      }
    }

    & > div:last-child {
      padding-left: 0px !important;
    }
  }

  & > div:last-child {
    padding-left: 85px;
  }
}

.categories > div > a {
  font-size: 0.6rem;
}

.categories > div > a.router-link-active {
  color: $color-accent;
}

</style>



// WEBPACK FOOTER //
// Categories.vue?4665db4b